import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { eTrangThaiDangKyAnActionTypeIds, ITrangThaiDangKyAnActionTypes } from "../../action-types/danh-muc/ITrangThaiDangKyAnActionTypes";
import { ITrangThaiDangKyAnPageState } from "../../page-state-model/danh-muc/ITrangThaiDangKyAnPageState";

const initialState: ITrangThaiDangKyAnPageState = {
    status: ePageBaseStatus.is_not_initialization,
    trangThaiDangKyAns: [],
    editingData: undefined,
    isShowEditModal: false,
};

export const trangThaiDangKyAnReducer = (state: ITrangThaiDangKyAnPageState = initialState, action: ITrangThaiDangKyAnActionTypes): ITrangThaiDangKyAnPageState => {
    switch (action.type) {
        case eTrangThaiDangKyAnActionTypeIds.LOAD_START:
            return {
                ...state,
                status: ePageBaseStatus.is_loading,
            };
        case eTrangThaiDangKyAnActionTypeIds.LOAD_SUCCESS:
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                trangThaiDangKyAns: action.payload,
            };
        case eTrangThaiDangKyAnActionTypeIds.LOAD_ERROR:
            NotifyHelper.Error(action.payload);
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                trangThaiDangKyAns: [],
            };

        case eTrangThaiDangKyAnActionTypeIds.SAVE_START:
            return {
                ...state,
                status: ePageBaseStatus.is_saving,
            };
        case eTrangThaiDangKyAnActionTypeIds.SAVE_SUCCESS:
            NotifyHelper.Success("Lưu dữ liệu thành công.");
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false,
                editingData: undefined,
            };
        case eTrangThaiDangKyAnActionTypeIds.SAVE_ERROR:
            NotifyHelper.Error(action.payload);
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            };

        case eTrangThaiDangKyAnActionTypeIds.DELETE_START:
            return {
                ...state,
                status: ePageBaseStatus.is_deleting,
            };
        case eTrangThaiDangKyAnActionTypeIds.DELETE_SUCCESS:
            NotifyHelper.Success("Xoá dữ liệu thành công.");
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            };
        case eTrangThaiDangKyAnActionTypeIds.DELETE_ERROR:
            NotifyHelper.Error(action.payload);
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            };

        case eTrangThaiDangKyAnActionTypeIds.SHOW_EDIT_MODAL:
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload,
            };
        case eTrangThaiDangKyAnActionTypeIds.CLOSE_EDIT_MODAL:
            return {
                ...state,
                isShowEditModal: false,
                editingData: undefined,
            };

        default:
            return state;
    }
};
